import ElevatedSvg from './elevated-svg';

type MaxBadgeSize = 'md' | 'lg';

interface ICalendarHeartIconProps {
    maxBadgeSize: MaxBadgeSize;
}

const CalendarHeartIcon = ({ maxBadgeSize }: ICalendarHeartIconProps) => {
    const widthValue = maxBadgeSize === 'lg' ? '5rem' : '4rem';

    return (
        <ElevatedSvg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 80 90"
            sx={{ width: { md: widthValue }, borderRadius: 1 }}
        >
            <defs>
                <clipPath id="clippath">
                    <rect fill="none" width="80" height="90" rx="16" ry="16" />
                </clipPath>
            </defs>
            <g clipPath="url(#clippath)">
                <g>
                    <rect fill="#ff0019" width="80" height="15" />
                    <rect fill="#fff" y="15" width="80" height="75" />
                    <path
                        fill="#001333"
                        d="M40,66.9c-.45,0-.9-.07-1.32-.22-7.03-2.35-14.87-10.8-14.87-19.18,0-6.13,3.87-9.07,7.17-9.7,3.03-.58,6.72.45,9.02,3.83,2.28-3.38,5.98-4.42,9.02-3.83,3.32.63,7.17,3.57,7.17,9.7,0,8.37-7.83,16.83-14.87,19.18-.43.15-.87.22-1.32.22ZM32.6,40.02c-.4,0-.78.03-1.17.12-2.53.48-5.25,2.68-5.25,7.37,0,7.15,7,14.85,13.25,16.93.37.12.77.12,1.13,0,6.25-2.08,13.25-9.78,13.25-16.93,0-4.68-2.72-6.88-5.25-7.37-2.62-.5-5.95.68-7.47,4.48-.37.9-1.83.9-2.2,0-1.3-3.25-3.93-4.58-6.3-4.58v-.02Z"
                    />
                </g>
            </g>
        </ElevatedSvg>
    );
};

export default CalendarHeartIcon;
